// extracted by mini-css-extract-plugin
module.exports = {"Recipe":"Recipes_Recipe__AIPXG","Expand":"Recipes_Expand__wELcZ"};